import * as Preact from "preact"

import App from "@frog/source/models/App.js"
import Navigation from "@frog/source/models/Navigation.js"
import Director from "@frog/source/juice/Director.js"
import Encounters from "@frog/source/data/encounters/encounters.js"

import "@frog/source/views/app/screens/CombatEncounterScreen.view.less"
// import Stage from "@frog/source/views/app/stage/Stage.view.js"

import {loader} from "@frog/source/utility/canvas/gl/render.js"

export default class CombatEncounterScreen {
    render() {
        if(loader.isPreloaded != true) {
            return (
                <div class="Loading">
                    Loading! {Math.round(loader.progress || 0)}%
                    <div class="LoadingBar">
                        <div class="Fill" style={{"width": loader.progress + "%"}}/>
                    </div>
                </div>
            )
        }
        let stage = App.game.encounter.stage
        if(Director.steps[0] != undefined
        && Director.steps[0].stage != undefined) {
            stage = Director.steps[0].stage
        }
        return
        return (
            <div class="CombatEncounterScreen">
                <HeadsupInterface stage={stage}/>
                <SuccessModal/>
                <FailureModal/>
            </div>
        )
    }
}

////////////////////////
// HEADSUP INTERFACE //
//////////////////////

class HeadsupInterface {
    // <UnitDetails/>
    // <Objective stage={this.props.stage}/>
    // <div class="Buttons"><MenuButton/></div>
    render() {
        return (
            <div class="HeadsupInterface">
                <div class="Buttons">
                    <UndoButton/>
                    <EndTurnButton/>
                </div>
            </div>
        )
    }
}

class MenuButton {
    render() {
        return (
            <div class="MenuButton" isActive={true} encounterSlug={App.game.encounter.slug} onClick={this.onClick}>
            </div>
        )
    }
    onClick(event) {
        Navigation.state.minimenu = { "section": "MainSection" }
    }
}

class EndTurnButton {
    render() {
        return (
            <div class="EndTurnButton"
                onMouseDown={this.onDown}
                onTouchStart={this.onDown}
                onMouseUp={this.onUp}
                onTouchEnd={this.onUp}
                encounterSlug={App.game.encounter.slug}
                isActive={this.isActive}>
                End Turn
            </div>
        )
    }
    get isActive() {
        return Director.isPerforming != true
    }
    onDown(event) {
        event.stopPropagation()
        App.game.encounter.endPlayerTurn()

        // FMODManager.playOneShot('event:/SFX/UI/UI_Click');
    }
    onUp(event) {
        event.stopPropagation()
    }
}

class UndoButton {
    render() {
        return (
            <div class="UndoButton"
                onMouseDown={this.onDown}
                onTouchStart={this.onDown}
                onMouseUp={this.onUp}
                onTouchEnd={this.onUp}
                encounterSlug={App.game.encounter.slug}
                isActive={this.isActive}>
                Undo
            </div>
        )
    }
    get isActive() {
        return App.game.encounter.previousStages.length > 0
    }
    onDown(event) {
        event.stopPropagation()
        App.game.encounter.undoAction()

        // FMODManager.playOneShot('event:/SFX/UI/UI_Back');
    }
    onUp(event) {
        event.stopPropagation()
    }
}

///////////////////
// UNIT DETAILS //
/////////////////

import * as Objdict from "objdict"

class UnitDetails {
    render() {
        if(App.game.encounter.selection.selectedUnit != undefined) {
            const unit = App.game.encounter.selection.selectedUnit
            if(unit.affiliation == "none") return
            return (
                <div class="UnitDetails" state="selected">
                    <UnitDetailsHeader unit={unit}/>
                    <div class="Skills">
                        {unit.skills.map((skillKey) => {
                            const skill = skills.get(skillKey)
                            if(skill == undefined) return
                            const skillView = skillViews[skill.information] || skillViews["generic"]
                            return (
                                <div class="Skill"
                                    onClick={onClickSkill(skill)}
                                    hasEnergyForInvokingSkills={unit.energy["invoke skill"] != false}
                                    isSelected={skillKey == (App.game.encounter.selection.selectedSkillKey || (unit.energy["move"] === false ? unit.skills[0] : undefined))}>
                                    {skillView({unit, skill})}
                                </div>
                            )
                        })}
                    </div>
                </div>
            )
        }
        if(App.game.encounter.selection.hoveredUnit != undefined) {
            const unit = App.game.encounter.selection.hoveredUnit
            if(unit.affiliation == "none") return
            return (
                <div class="UnitDetails" state="hovered">
                    <UnitDetailsHeader unit={unit}/>
                </div>
            )
        }
        return (
            <div class="UnitDetails" state="hidden"/>
        )
    }
}

class UnitDetailsHeader {
    render() {
        const unit = this.props.unit
        return (
            <div class="Header">
                <div class="Name">{unit.name}</div>
                <div class="Sprite" style={{"background-image": "url(" + unit.image + ")"}}/>
            </div>
        )
    }
}

const skillViews = {
    "strike": function({unit, skill}) {
        return [
            <div class="Name">Attack</div>,
            <div class="Description">
                Targets enemies [{skill.range.min}] tile{skill.range.min > 1 ? "s" : ""} away.<br/>
                Deals (2 / 3 / 4) <ElementIcon elementKey={unit.element}/> {unit.element} damage.
            </div>
        ]
    },
    "none": function() {},
    "generic": function({unit, skill}) {
        return [
            <div class="Name">{skill.name instanceof Function ? skill.name() : skill.name}</div>,
            <div class="Description">
                {skill.description instanceof Function ? skill.description() : skill.description}
            </div>
        ]
    }
}

function onClickSkill(skill) {
    return (event) => {
        event.stopPropagation()
        App.game.encounter.selection.isIgnoringForFrame = true
        App.game.encounter.selection.selectedSkillKey = skill.key
        // if(App.game.encounter.selection.selectedSkillKey == undefined) {
        //     App.game.encounter.selection.selectedSkillKey = skill.key
        // } else {
        //     App.game.encounter.selection.selectedSkillKey = undefined
        // }
    }
}

class ElementIcon {
    render() {
        return (
            <div class="ElementIcon" style={{"background-image": "url(" + elements[this.props.elementKey].icon + ")"}}/>
        )
    }
}

class UnitSkills {
    render() {
        return (
            <div class="UnitSkills">
                {this.props.unit.skills.map((skillKey) => (
                    <Skill skillKey={skillKey} unit={this.props.unit}/>
                ))}
            </div>
        )
    }
}

import skills from "@frog/source/data/skills.js"

class Skill {
    render() {
        const skill = skills.get(this.props.skillKey)
        if(skill == undefined) {
            return
        }
        return (
            <div class="Skill"
                canSelect={this.canSelect}
                onMouseDown={this.onDown}
                onTouchStart={this.onDown}
                onMouseUp={this.onUp}
                onTouchEnd={this.onUp}
                onClick={this.onClick}>
                {skill.name}
            </div>
        )
    }
    get canSelect() {
        return App.game.encounter.selection.canSelectUnitSkill(this.props.unit, this.props.skillKey)
    }
    get onClick() {
        return (event) => {
            event.stopPropagation()
            if(App.game.encounter.selection.selectedSkillKey == undefined) {
                App.game.encounter.selection.selectedSkillKey = this.props.skillKey
            } else {
                App.game.encounter.selection.selectedSkillKey = undefined
            }
        }
    }
    onUp(event) {
        event.stopPropagation()
    }
}

/////////////
// MODALS //
///////////

import LoseEye from "@frog/source/assets/images/cryptid-tactics/UI/UI_eye_lose.png"
import WinEye from "@frog/source/assets/images/cryptid-tactics/UI/UI_eye_win.png"

class SuccessModal {
    render() {
        if(Navigation.state.modal == undefined
        || Navigation.state.modal.type != "success") {
            return
        }
        return (
            <div class="SuccessModal" encounterSlug={App.game.encounter.slug}
                onMouseDown={this.onClick} onTouchStart={this.onClick}>
                <div class="Banner" isActive={true}>
                    Success!
                </div>
            </div>
        )
    }
    onClick(event) {
        console.log("CoNTINUE")
        Navigation.state.modal.hasClickedContinue = true
    }
}

class FailureModal {
    render() {
        if(Navigation.state.modal == undefined
        || Navigation.state.modal.type != "failure") {
            return
        }
        return (
            <div class="FailureModal" encounterSlug={App.game.encounter.slug}
                onMouseDown={this.onClick} onTouchStart={this.onClick}>
                <div class="Banner" isActive={true}>
                    Failure
                </div>
            </div>
        )
    }
    onClick(event) {
        Navigation.state.modal.hasClickedContinue = true
    }
}

// ///////////////
// // MINI MAP //
// /////////////
//
// // TODO: move this into sprite declaration
// const UNIT_HEADS = {
//     // "pusher": require("@frog/source/assets/images/bomber-tactics/bomber-d-head.png").default,
//     // "puller": require("@frog/source/assets/images/bomber-tactics/bomber-a-head.png").default,
//     // "aoe-er": require("@frog/source/assets/images/bomber-tactics/bomber-b-head.png").default,
//     // "flipper": require("@frog/source/assets/images/bomber-tactics/bomber-c-head.png").default,
// }
//
// import * as deathzone from "@frog/source/data/deathzone.js"
//
// class MiniMap {
//     render() {
//         return (
//             <div class="MiniMap" style={{
//                 "width": this.props.stage.world.width + "em",
//                 "height": this.props.stage.world.height + "em",
//             }}>
//                 <div class="Terrain">
//                     {this.terrain}
//                 </div>
//                 <div class="Units">
//                     {this.units}
//                 </div>
//             </div>
//         )
//     }
//     get terrain() {
//         const views = []
//         Objdict.forEach(this.props.stage.world.terrain, (terrain, key) => {
//             let type = terrain.position.z + terrain.size.z <= 0 ? "hole" : "floor"
//             let isInDeathZone = deathzone.isInDanger(this.props.stage, terrain.position)
//             views.push(
//                 <div class="Tile" type={type} isInDeathZone={isInDeathZone} style={{
//                     "left": terrain.position.x + "em",
//                     "top": terrain.position.y + "em"
//                 }}/>
//             )
//         })
//         return views
//     }
//     get units() {
//         const views = []
//         Objdict.forEach(this.props.stage.units, (unit) => {
//             if(unit.isDead == true) return
//             views.push(
//                 <div class="Unit" style={{
//                     "background-image": "url(" + UNIT_HEADS[unit.reference] + ")",
//                     "left": unit.position.x + "em",
//                     "top": unit.position.y + "em",
//                 }}/>
//             )
//         })
//         return views
//     }
// }

////////////////
// OBJECTIVE //
//////////////

class Objective {
    render() {
        return (
            <div class="Objective">
                <div class="Count" >{this.count}</div>
            </div>
        )
    }
    get count() {
        return Object.values(this.props.stage.units).filter((unit) => {
            return unit.isDead != true && unit.affiliation == "bad"
        }).length
    }
}
